import Entity from '../../../../../../foundation/domain/Entity';
import EntityId from '../../../../../../foundation/domain/EntityId';
import * as Voca from 'voca';
import Position from './Position';
import Course from '../course/Course';

export default class Lesson extends Entity<Lesson> {

	public constructor (id: EntityId<Lesson>, private courseId: EntityId<Course>, private title: string, private subtitle: string, private content: string, private active: boolean, private prerequisiteLessonIds: EntityId<Lesson>[], private position: Position) {
		super(id);
	}

	public static create () {
		return new Lesson(EntityId.create<Lesson>(), EntityId.create<Course>(), '', '', '', true, [], new Position(10, 10));
	}

	/*
	 * Query methods
	 */

	public getCourseId () {
		return this.courseId;
	}

	public hasCourseId () {
		return this.courseId.getValue() !== null;
	}

	public getTitle () {
		return this.title;
	}

	public getSubtitle () {
		return this.subtitle;
	}

	public isActive () {
		return this.active;
	}

	public getContent () {
		return this.content;
	}

	public hasContent () {
		return this.content !== '';
	}

	public getPrerequisiteLessonIds () {
		return this.prerequisiteLessonIds;
	}

	public getSlug () {
		return '/lesson/' + this.getId().getValue() + '/' + Voca.slugify(Voca.stripTags(this.title));
	}

	public getPosition () {
		return this.position;
	}

	/*
	 * Command methods
	 */

	public updateCourseId (courseId: EntityId<Course>) {
		this.courseId = courseId;
		return this;
	}

	public updateTitle (title: string) {
		this.title = title;
		return this;
	}

	public updateSubtitle (subtitle: string) {
		this.subtitle = subtitle;
		return this;
	}

	public updateContent (content: string) {
		this.content = content;
		return this;
	}

	public toggleActive () {
		this.active = !this.active;
		return this;
	}

	public updatePrerequisiteLessonIds (prerequisiteLessonIds: EntityId<Lesson>[]) {
		this.prerequisiteLessonIds = prerequisiteLessonIds;
		return this;
	}

	public updateX (x: number) {
		this.position = new Position(x, this.position.getY());
		return this;
	}

	public updateY (y: number) {
		this.position = new Position(this.position.getX(), y);
		return this;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/aggregates/lesson/Lesson.ts